var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container mt-5" },
    [
      _c("h3", [_vm._v("BeNeat Blog")]),
      _vm._v(" "),
      _c("Blogs", {
        ref: "blog-component",
        attrs: {
          curPage: _vm.curPage,
          queryDataPage: _vm.queryData.page,
          queryDataLimit: _vm.queryData.limit,
          showInPageConent: false
        },
        on: { visiblePageNumber: _vm.visiblePageNumber }
      }),
      _vm._v(" "),
      _vm.totalPage > 1
        ? _c("div", { staticClass: "pagination" }, [
            _c(
              "nav",
              { staticClass: "d-flex justify-content-center" },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "", disabled: _vm.curPage === 1 },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.changePage(_vm.curPage - 1)
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-angle-left",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _c("span", { staticClass: "text-pagination-back" }, [
                      _vm._v(" Back")
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.visiblePageNumber(_vm.totalPage), function(
                  pageNumber
                ) {
                  return _c(
                    "a",
                    {
                      key: pageNumber,
                      class: { active: _vm.curPage == pageNumber },
                      attrs: { href: "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changePage(pageNumber)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(pageNumber) +
                          "\n            "
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "",
                      disabled: _vm.curPage === _vm.totalPage
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.changePage(_vm.curPage + 1)
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "text-pagination-next" }, [
                      _vm._v("Next ")
                    ]),
                    _c("i", {
                      staticClass: "fa fa-angle-right",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ],
              2
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-640e3e54", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-640e3e54","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blogs/Index.vue
// module id = 2464
// module chunks = 0